export default "__VITE_ASSET__e32205d9__"